import { RechartsTheme } from './RechartsTheme';

/**
 * Dark mode theme
 *
 * @experimental
 */
export const darkTheme: RechartsTheme = {
  grid: {
    stroke: '#3f3f46',
    fill: 'none',
  },
};
